<template>
  <div class="toc-container">
    <div class="toc-header">
      <h3>目录</h3>
    </div>
    <nav class="toc-nav">
      <ul>
        <li 
          v-for="(item, index) in tocItems" 
          :key="index"
          :class="['toc-item', `toc-level-${item.level}`, { active: item.id === activeId }]"
        >
          <a 
            :href="`#${item.id}`" 
            @click.prevent="scrollTo(item.id)"
            class="toc-link"
          >
            {{ item.text }}
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'BlogToc',
  props: {
    // 可以传入自定义的目录项，如果不传则自动从页面提取
    items: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      tocItems: [],
      activeId: ''
    }
  },
  mounted() {
    this.generateToc()
    this.setupScrollSpy()
  },
  methods: {
    generateToc() {
      if (this.items.length > 0) {
        this.tocItems = this.items
        return
      }
      
      // 自动从页面中提取标题
      const mdContainer = document.getElementById('mdtext') //Todo 使用参数 
      if (!mdContainer) return
      
      const headings = mdContainer.querySelectorAll('h1, h2, h3, h4, h5, h6')
      this.tocItems = Array.from(headings).map(heading => {
        let level = parseInt(heading.tagName.substring(1))
        
        // 如果第一个标题是h1，将其视为level 0（主要标题）
        if (headings[0].tagName === 'H1' && heading.tagName === 'H1') {
          level = 0
        }
        
        return {
          id: this.generateId(heading.textContent),
          text: heading.textContent,
          level: level,
          element: heading
        }
      })
      
      // 为标题元素添加id
      this.tocItems.forEach(item => {
        if (item.element && !item.element.id) {
          item.element.id = item.id
        }
      })
    },
    
    generateId(text) {
      return text
        .toLowerCase()
        .replace(/[^\w\u4e00-\u9fa5]+/g, '-')
        .replace(/^-+|-+$/g, '')
    },
    
    scrollTo(id) {
      const element = document.getElementById(id)
      if (element) {
        const offsetTop = element.getBoundingClientRect().top + window.pageYOffset - 80
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        })
        this.activeId = id
      }
    },
    
    setupScrollSpy() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.activeId = entry.target.id
          }
        })
      }, {
        rootMargin: '-20% 0px -70% 0px',
        threshold: 0
      })
      
      this.tocItems.forEach(item => {
        if (item.element) {
          observer.observe(item.element)
        }
      })
    }
  }
}
</script>

<style scoped>
.toc-container {
  position: sticky;
  top: 20px;
  background: #343739;
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  border-left: 4px solid #aabbff;
}

.toc-header {
  margin-bottom: 15px;
  border-bottom: 1px solid #e9ecef;
  padding-bottom: 10px;
}

.toc-header h3 {
  margin: 0;
  color: white;
  font-size: 1.2em;
}

.toc-nav ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.toc-item {
  margin: 4px 0;
  line-height: 1.4;
}

.toc-level-0 {
  font-weight: bold;
  font-size: 1.1em;
  margin: 8px 0;
  color: rgb(197, 194, 194);
}

.toc-level-1 {
  padding-left: 0;
  font-weight: 600;
}

.toc-level-2 {
  padding-left: 16px;
  font-size: 0.95em;
}

.toc-level-3 {
  padding-left: 32px;
  font-size: 0.9em;
  color: #6c757d;
}

.toc-level-4 {
  padding-left: 48px;
  font-size: 0.85em;
  color: #6c757d;
}

.toc-link {
  text-decoration: none;
  color: inherit;
  transition: color 0.2s ease;
  display: block;
  padding: 2px 0;
}

.toc-link:hover {
  color: #ffffff;
}

.toc-item.active .toc-link {
  color: #007bff;
  font-weight: 600;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .toc-container {
    position: static;
    margin: 20px 0;
  }
}
</style>